<div *ngIf="data" class="pass-container">
    <finder-component-header
        *ngIf="headerData"
        [data]="headerData"
    ></finder-component-header>

    <ng-container *ngIf="data?.pass?.length">
        <div class="pass-card" *ngFor="let pass of data?.pass; index as passIndex">
            <div class="buy-info">
                <div *ngIf="pass?.logo" class="logo">
                    <finder-picture [picture]="pass.logo" ></finder-picture>
                </div>
                <div class="price-info">
                    <h2 class="pass-title" [innerHTML]="pass?.passTitle | safeHtml"></h2>
                    <div class="price-detail">
                        <div>
                            <div class="price" [innerHTML]="pass?.passPrice | safeHtml"></div>
                            <span class="text" [innerHTML]="data?.labels?.passPlusTaxMessage | safeHtml"></span>
                        </div>
                        <span class="vertical-separator"></span>
                        <span class="buy-option-detail" [innerHTML]="pass?.passPurchaseDetail | safeHtml"></span>
                    </div>
                    <div class="buy-option">
                        <finder-button
                            *ngIf="pass?.button"
                            [href]="pass.button?.ctaButtonUrl"
                            [target]="pass.button?.ctaButtonTarget"
                            [fullWidth]="true"
                            theme="primary"
                            id="{{pass?.passTitle}}-{{pass.button?.ctaButtonText}}"
                            >{{pass.button?.ctaButtonText}}
                        </finder-button>
                        <div *ngIf="!pass?.button" class="buy-option-unavailable" [innerHTML]="data?.labels?.unavailable | safeHtml"></div>
                    </div>
                </div>
            </div>

            <div class="pass-detail">
                <h2 class="pass-highlights-title" [innerHTML]="data?.labels?.passHighlights | safeHtml"></h2>
                <ul class="highlights-list-container" *ngIf="pass?.passHighlights">
                    <li class="item-container" *ngFor="let passHighlights of pass.passHighlights">
                        <finder-font-icon size="inherit" [name]="passHighlights.icon"></finder-font-icon>
                        <p class="item" [innerHTML]="passHighlights.name | safeHtml"></p>
                    </li>
                </ul>
                <div *ngIf="pass?.modal" class="pass-detail-modal">
                    <finder-button
                        id="{{pass?.passTitle | kebabCase}}-{{pass?.modal.ctaTitle | kebabCase}}"
                        (click)="openPassDetailModal(passIndex)"
                        [ariaLabel]="pass?.modal.ctaAriaLabel"
                        anchor="true">{{pass?.modal.ctaTitle}}
                    </finder-button>
                </div>
            </div>
        </div>
    </ng-container>
</div>
